<template>
  <CCard>
    <CCardHeader class="d-flex ">
      <h2
        v-if="!subId"
        class="mb-0"
      >
        New Subscription
      </h2>
      <h2
        v-else
        class="mb-0"
      >
        Edit Subscription
      </h2>
    </CCardHeader>
    <CCardBody>
      <form
        v-if="!subId || !user_loading"
        autocomplete="off"
        @submit.prevent="submit"
      >
        <CRow>
          <CCol
            md="6"
            lg="4"
          >
            <label class="d-block">Expire At</label>
            <vc-date-picker
              v-model="new_subscription.expire_at"
              mode="dateTime"
              :is24hr="is24Hour"
              :min-date="new Date()"
            >
              <template #default="{ inputValue, inputEvents }">
                <input
                  class="form-control"
                  :value="formattedExpireDate"
                  v-on="inputEvents"
                >
              </template>
            </vc-date-picker>
          </CCol>

          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model="new_subscription.quantity"
              label="Quantity"
              type="number"
              min="1"
              autocomplete="email"
              :add-input-classes="{'is-invalid': hasError('quantity')}"
              :invalid-feedback="getError('quantity')"
            />
          </CCol>

          <CCol
            v-if="!subId"
            md="6"
            lg="4"
          >
            <CSelect
              v-model="new_subscription.usage_type"
              label="Subscription Type"
              :options="typeOptions"
            />
          </CCol>
        </CRow>

        <div class="d-flex mt-3">
          <CButton
            type="submit"
            color="primary"
            class="mr-4"
          >
            Save
          </CButton>
          <CButton
            color="secondary"
            @click="$router.push({name: 'Enterprise User Subscriptions', params: {id: id}})"
          >
            Cancel
          </CButton>
        </div>
      </form>
    </CCardBody>
  </CCard>
</template>

<script>
import hasApiValidation from "@/mixins/hasApiValidation";

export default {
  name: "EditEnterpriseUserSubscription",
  mixins: [hasApiValidation],
  props: ['id', 'subId'],
  data() {
    return {
      roles: [],
      typeOptions: [
        { value: 1, label: 'Spinning® Studio Connect Tablet' },
        { value: 2, label: 'Spinning® Studio Connect TV' }
      ],
      new_subscription: {
        expire_at: null,
        quantity: 1,
        usage_type: 1,
      },
      user_loading: false,
    }
  },
  computed: {
    formattedExpireDate(){
      return this.$formatDateTime(this.new_subscription.expire_at);
    },
    is24Hour() {
      return this.$is24Hours();
    }
  },
  mounted() {
    this.user_loading = true;
    if (this.subId) {
      // this.fetchSub(this.subId);
    }
  },
  methods: {
    submit() {
      this.save();
    },
    save() {
      this.setErrors({});
      this.$http.post(`/enterprise-users/${this.id}/subscriptions`, {
        ...this.new_subscription, 
        expire_at: this.new_subscription.expire_at 
          ? this.$moment(this.new_subscription.expire_at).utc().format("YYYY-MM-DD HH:mm:ss") 
          : null
      })
      .then(() => {
        this.$toast.success('Created');
        this.setErrors({});
        this.$router.push({name: 'Enterprise User Subscriptions', params: {id: this.id}});
      }).catch(({response}) => {
        this.$toast.error(response.data.message);
        this.setErrors(response.data.errors);
      })
    },
  },
}
</script>

<style scoped>

</style>
